import { Outlet, useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { PlusIcon } from 'src/shared/components/icons/sidebar/plus-icon'
import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { cn } from 'src/shared/utils/cn'

function AddButton({ onClick }: { onClick: () => void }) {
  const { bpSwitch } = useBreakpoint()

  return (
    <div
      onClick={onClick}
      className="flex size-[60px] items-center justify-center rounded-full bg-primary text-white shadow-[0_0_7px_1px_#45D88E] transition-all duration-200 hover:scale-110 hover:cursor-pointer md:size-[64px] xl:size-[70px]"
    >
      <PlusIcon
        size={bpSwitch({
          xl: 28,
          md: 26,
          default: 24,
        })}
      />
    </div>
  )
}

export default function BusinessLayout() {
  const { isMobile } = useBreakpoint()
  const navigate = useNavigate()

  const addButtonOnClick = () => {
    navigate(paths.business.create.getHref('1'))
  }

  return (
    // padding added to ensure content is not hidden by the add button
    <div className="p-[20px] md:p-[48px] xl:px-[76px] xl:py-[56px]">
      <Outlet />
      <div
        className={cn(
          'absolute bottom-[68px] right-[58px] z-20 md:bottom-[78px] md:right-[68px]',
          isMobile && 'hidden',
        )}
      >
        <AddButton onClick={addButtonOnClick} />
      </div>
    </div>
  )
}
